import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Booking from "./views/booking/Booking.vue";
import BookingList from "./views/booking/BookingList.vue";
import Options from "./views/booking/Options.vue";
import SupplierPrestationEdit from "./views/booking/SupplierPrestationEdit.vue";
import OnPlaceAgentEdit from "./views/booking/OnPlaceAgentEdit.vue";
import Reviews from "./views/booking/Reviews.vue";
import CalendarSearch from "./views/calendar/CalendarSearch.vue";
import Login from "./views/Login.vue";
import CustomerEdition from "@/views/customer/CustomerEdition.vue";
import {Role, authMethods} from "@/utils/user";
import DocumentsRoutes from "@/routes/documents-router";
import AccountingRoutes from "@/routes/accounting-router";
import ExtranetRoutes from "@/routes/extranet-router";
import StatsRoutes from "@/routes/stats-router";
import Noop from "@/components/Noop";
import ActionsRoutes from "@/routes/actions-router";
import CustomersList from "./views/customer/CustomersList";
import BookingReport from "./views/booking/BookingReport";
import Users from "./views/admin/Users";
import Live from "./views/Live";
//import SupplierAccountingStats from "./views/stats/SupplierAccountingStats";
import PackageRoutes from "@/routes/package-router";
import HLRoutes from "@/routes/hl-router";
import CanceledBooking from "@/views/booking/CanceledBooking.vue";
import BigQueryAnalytics from "@/views/admin/BigQueryAnalytics.vue";
import Meta from "@/views/admin/Meta.vue";
import ExportVentes from "@/views/accounting/exports/ExportVentes.vue";
import ExportClients from "@/views/accounting/exports/ExportClients.vue";
import ExportEcritures from "@/views/accounting/exports/ExportEcritures.vue";
import ExportCheck from "@/views/accounting/exports/ExportCheck.vue";
import AverageFlight from "@/views/averageReview/AverageFlight.vue";
import AverageHotel from "@/views/averageReview/AverageHotel.vue";
import ListLead from "@/views/lead/ListLead.vue";
import Lead from "@/views/lead/Lead.vue";
import PhoneCalls from "@/views/admin/PhoneCalls.vue";
import Forbidden from "@/views/Forbidden.vue";
import ReleaseNotes from "@/views/admin/ReleaseNotes.vue";
import AdminUtils from "@/views/admin/AdminUtils.vue";
import IssuedBooking from "@/views/booking/IssuedBooking.vue";
import TypebotSubmissions from "@/views/thirdparty/TypebotSubmissions.vue";
import ViewersMapCheckerView from "@/views/admin/ViewersMapCheckerView.vue";
import NaturalLanguageQueryView from "@/views/admin/NaturalLanguageQueryView.vue";
import NaturalLanguageQueryDetailView from "@/views/admin/NaturalLanguageQueryDetailView.vue";

Vue.use(Router);

const routes = [
  {
    path: "/forbidden",
    name: "Forbidden",
    component: Forbidden,
    meta: {unsecure: true,}
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      plainLayout: true,
      unsecure: true,
    },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {roles: [Role.resas]}
  },
  {
    path: "/live",
    name: "Live",
    component: Live,
    meta: {roles: [Role.resas]}
  },
  {
    path: "/vente",
    name: "Vente",
    component: Noop,
    children: [
      {
        path: "dossier",
        name: "BookingList",
        component: BookingList,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Dossiers"}],
        },
      },
      {
        path: "dossier/:id",
        name: "Booking",
        component: Booking,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [
            {name: "Dossiers", route: {name: "BookingList"}},
            {name: (ids) => `Booking n°${ids[0]}`},
          ],
          websocketViewers: true,
        },
      },
      {
        path: "options",
        name: "Options",
        component: Options,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Options"}],
        },
      },
      {
        path: "dossier-annule",
        name: "CancelledBookings",
        component: CanceledBooking,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "CancelledBookings"}],
        },
      },
      {
        path: "dossier-litige",
        name: "IssuedBooking",
        component: IssuedBooking,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Dossiers avec litiges"}],
        },
      },
      {
        path: "/calendrier",
        name: "CalendarSearch",
        component: CalendarSearch,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Calendrier de prix"}],
        },
      },
      {
        path: "/fournisseurs-prestation",
        name: "SupplierPrestationEdit",
        component: SupplierPrestationEdit,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Fournisseurs prestation"}],
        },
      },
      {
        path: "/agents-sur-place",
        name: "OnPlaceAgentEdit",
        component: OnPlaceAgentEdit,
        meta: {
            roles: [Role.resas],
            breadcrumb: [{name: "Agents sur place"}],
        },
      },
      {
        path: "/avis",
        name: "Reviews",
        component: Noop,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Avis"}],
        },
        children: [
          {
            path: "moderation",
            name: "avis-moderation",
            component: Reviews,
            metas: {roles: [Role.resas]}
          },
          {
            path: "hotel",
            name: "avis-hotels",
            component: AverageHotel,
            metas: {roles: [Role.resas]}
          },
          {
            path: "vol",
            name: "avis-vols",
            component: AverageFlight,
            metas: {roles: [Role.resas]}
          },
        ],
      },
      {
        path: "/report-dossier",
        name: "booking.report",
        component: BookingReport,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Dossiers"}],
        },
      },
      {
        path: "/list-leads",
        name: "listleads",
        component: ListLead,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Leads"}],
        },
      },
      {
        path: "/lead/:id",
        name: "lead",
        component: Lead,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Leads"}],
        },
      },

      {
        path: "/thirdparty/typebot",
        name: "Typebot",
        component: TypebotSubmissions,
        props: false,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Typebot"}],
        },
      },

    ],
  },
  {
    path: "/customer",
    name: "Clients",
    component: Noop,
    children: [
      {
        path: "/customer/:id",
        name: "customer-edition",
        component: CustomerEdition,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [
            {name: "Clients"},
            {name: (ids) => `Client n°${ids[0]}`},
          ],
        },
      },
      {
        path: "/customer",
        name: "customer-search",
        component: CustomersList,
        props: true,
        meta: {
          roles: [Role.resas],
          breadcrumb: [{name: "Clients"}],
        },
      },
    ],
  },
  {
    path: "/admin",
    name: "Admin",
    component: Noop,
    children: [
      {
        path: "users",
        name: "AdminUsers",
        component: Users,
      },
      {
        path: "analyze",
        name: "BigQueryAnalytics",
        component: BigQueryAnalytics,
      },
      {
        path: "meta",
        name: "Meta",
        component: Meta,
      },
      {
        path: "calls",
        name: "PhoneCalls",
        component: PhoneCalls,
        meta: {
          roles: [Role.resas]
        }
      },
      {
        path: "release-notes",
        name: "ReleaseNotes",
        component: ReleaseNotes,
        meta: {
          roles: [Role.resas]
        }
      },
      {
        path: 'utils',
        name: 'AdminUtils',
        component: AdminUtils,
      },
      {
        path:'utils/viewers',
        name: 'ViewersMapChecker',
        component: ViewersMapCheckerView
      },
      {
        path:'utils/nql',
        name: 'NaturalLanguageQuery',
        component: NaturalLanguageQueryView
      },
      {
        path:'utils/nql/:id',
        name: 'NaturalLanguageQueryDetail',
        component: NaturalLanguageQueryDetailView,
        props: true,
      },
    ],
  },
];

const router = new Router({
  mode: "history",
  routes: routes.concat(
    DocumentsRoutes,
    AccountingRoutes,
    ExtranetRoutes,
    StatsRoutes,
    HLRoutes,
    ActionsRoutes,
    PackageRoutes
    //, ...
  ),
});
router.beforeEach((to, from, next) => {

  if (to.meta && to.meta.unsecure) {
    return next()
  } else {
    const routeRoles = (to.meta && to.meta.roles) || []
    const user = JSON.parse(localStorage.getItem("user"));
    if (user == null){
      return next({
        name: "Login",
        query: {redirect: to.fullPath},
      })
    }
    const isAdmin = user.roles.some(r => r.id === Role.admin)
    const hasRole = routeRoles.some(role => user.roles.some(ur => ur.id === role))

    if (!isAdmin && !hasRole) {
      return next({name: 'Forbidden'})
    }

    return next();
  }

});

export default router;
